// extracted by mini-css-extract-plugin
export default {"root":"Projects_root__vfb1f","gridList":"Projects_gridList__Prkve","project":"Projects_project__hqta+","spinner":"Projects_spinner__owzYd","search":"Projects_search__NdZ53"};